// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 416 ? "component---gatsby-theme-landing-page-src-pages-contentful-landing-page-slug-js" : chunkId) + "-" + {"108":"0e29049aac951cb409e4","416":"bc125065fb25ce94ab0d","452":"082a129d78c50cfe1545"}[chunkId] + ".js";
};